import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * The body of a relational tab.
 *
 * Vertical scroll only, and `minWidth: 0`, so a table wider than the window
 * scrolls in its own viewport instead of stretching the page and dragging the
 * tab strip sideways with it.
 */
export function RelatedPanel({ children }: { children: ReactNode }) {
  return (
    <Box
      sx={{
        flexGrow: 1,
        minWidth: 0,
        overflowY: 'auto',
        overflowX: 'hidden',
        p: 2,
        bgcolor: 'grey.50',
      }}
    >
      {children}
    </Box>
  );
}
